import { render } from "./JobDetails.vue?vue&type=template&id=4e82cb16"
import script from "./JobDetails.vue?vue&type=script&lang=js"
export * from "./JobDetails.vue?vue&type=script&lang=js"

import "./JobDetails.vue?vue&type=style&index=0&id=4e82cb16&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__